export default {
	headline: 'Kezdőoldal',
};
